import React from 'react';
import { Field } from 'redux-form';
import { SelectField } from 'Common/SemanticWrapper';
import { states } from 'Common/Constants';

export default props => {
  const { name, ...rest } = props;

  return (
    <Field
      name={name}
      component={SelectField}
      label={'State'}
      options={states}
      search={stateFilter}
      {...rest}
    />
  );
};

const stateFilter = (options, query) => {
  const re = new RegExp('^' + query, 'i');
  return options.filter(opt => re.test(opt.text));
};



// WEBPACK FOOTER //
// ./src/common/Components/StateDropdown/StateDropdown.js